import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeopleActiveRoute extends Route {
  @service store;

  model() {
    return this.modelFor('resources').people.active;
  }
}

export default instrumentRoutePerformance(ResourcesPeopleActiveRoute);
